'use strict';

var anObject = require('../internals/an-object');

var aFunction = require('../internals/a-function'); // https://github.com/tc39/collection-methods


module.exports = function ()
/* ...elements */
{
  var collection = anObject(this);
  var remover = aFunction(collection['delete']);
  var allDeleted = true;
  var wasDeleted;

  for (var k = 0, len = arguments.length; k < len; k++) {
    wasDeleted = remover.call(collection, arguments[k]);
    allDeleted = allDeleted && wasDeleted;
  }

  return !!allDeleted;
};